// P2: Profile View Modal - Age calculation utility

/**
 * Calculate age from date of birth ISO string
 * @param {string} dobIso - Date of birth in ISO format (YYYY-MM-DD)
 * @returns {number|null} Age in years, or null if invalid
 */
export function getAgeFromDob(dobIso) {
  if (!dobIso) return null;
  
  try {
    const dob = new Date(dobIso);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    
    return age;
  } catch (e) {
    return null;
  }
}
